import $ from "jquery";
window.jQuery = window.$ = $
document.dispatchEvent(new Event('jquery:ready'))
